import React, { Component } from 'react';
import SumaContexto from '../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Spin, Input, Button, Popconfirm, Modal, Tooltip  } from 'antd';
import { EditOutlined,CheckOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import ServicioAdministracion from '../servicios/ServicioAdministracion'
import { withCookies } from 'react-cookie';
import Constantes from '../utilidades/Constantes'
import Validadores from '../utilidades/Validadores'
import Utilidades from '../utilidades/Utilidades'

class Normatividad extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3
    }

    state = {
        cargando: true,
        componente: this.ENUM_COMPONENTE.CARGANDO
    };

    constructor(props) {
        super(props);
        this.historyLocal = props.history;
        this.servicioAdministracion = new ServicioAdministracion(props);

        this.inputsDisabled = {};
    }


    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {

        let normatividades = await this.servicioAdministracion.obtenerNormatividades();
        if( normatividades ){
            normatividades.sort((a, b) => a.id > b.id ? 1 : -1);
            // Se procede a crear las referencias dinámicas para manejar los input, y los botones
            for( let normatividad of normatividades ){
                this.crearReferencias( normatividad.id );
            }
            this.setSumaState({ componente: this.ENUM_COMPONENTE.VER, cargando: false, 
                                inputsDisabled:this.inputsDisabled, normatividades });
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    crearReferencias = ( index ) => {
        this["refInput_pre_" + index] = React.createRef();
        this["refInput_res_" + index] = React.createRef();
        this["refInput_url_" + index] = React.createRef();
        this["refBtnEdit_" + index] = React.createRef();
        this["refBtnSave_" + index] = React.createRef();
        this["refBtnCancel_" + index] = React.createRef();
        this["refBtnEliminar_" + index] = React.createRef();
        this.inputsDisabled["refInput_pre_" + index] = { disabled: index !== 0 };
        this.inputsDisabled["refInput_res_" + index] = { disabled: index !== 0 };
        this.inputsDisabled["refInput_url_" + index] = { disabled: index !== 0 };
    }

    clicEditar = ( id ) => {
        let inputsDisabled = this.state.inputsDisabled;
        
        for( let normativida of this.state.normatividades ){
            if( normativida.id !== id ){
                // Se deshabilitan los elementos que no se van a trabajar
                if( this["refBtnEdit_" + normativida.id] ){
                    this["refBtnEdit_" + normativida.id].current.disabled = true;                
                    this["refBtnEdit_" + normativida.id].current.hidden = false;
                }
                if( this["refBtnSave_" + normativida.id] ){             
                    this["refBtnSave_" + normativida.id].current.hidden = true;
                }
                if( this["refBtnCancel_" + normativida.id] ){             
                    this["refBtnCancel_" + normativida.id].current.hidden = true;
                }
                if( this["refBtnEliminar_" + normativida.id] ){        
                    this["refBtnEliminar_" + normativida.id].current.disabled = true;        
                    this["refBtnEliminar_" + normativida.id].current.hidden = false;
                }
                if( this["refInput_pre_" + normativida.id] ){             
                    inputsDisabled["refInput_pre_" + normativida.id].disabled = true;
                }
                if( this["refInput_res_" + normativida.id] ){             
                    inputsDisabled["refInput_res_" + normativida.id].disabled = true;
                }
                if( this["refInput_url_" + normativida.id] ){             
                    inputsDisabled["refInput_url_" + normativida.id].disabled = true;
                }
            }else{
                // Se habilita el elemento que se desea trabajar
                this["refBtnEdit_" + id].current.hidden = true;
                this["refBtnEliminar_" + id].current.hidden = true;
                this["refBtnSave_" + id].current.hidden = false;
                this["refBtnCancel_" + id].current.hidden = false;
                inputsDisabled["refInput_pre_" + id].disabled = false;
                inputsDisabled["refInput_res_" + id].disabled = false;
                inputsDisabled["refInput_url_" + id].disabled = false;
            }
        }
        
        this.setSumaState({ inputsDisabled });
    }

    clicCancelar = ( id ) => {
        let inputsDisabled = this.state.inputsDisabled;
        let normatividades = this.state.normatividades;
        for( let normativida of normatividades ){
            if( normativida.id !== id ){
                // Se deshabilitan los elementos que no se van a trabajar
                if( this["refBtnEdit_" + normativida.id] ){
                    this["refBtnEdit_" + normativida.id].current.disabled = false;                
                    this["refBtnEdit_" + normativida.id].current.hidden = false;
                }
                if( this["refBtnSave_" + normativida.id] ){             
                    this["refBtnSave_" + normativida.id].current.hidden = true;
                }
                if( this["refBtnCancel_" + normativida.id] ){             
                    this["refBtnCancel_" + normativida.id].current.hidden = true;
                }
                if( this["refBtnEliminar_" + normativida.id] ){    
                    this["refBtnEliminar_" + normativida.id].current.disabled = false;                         
                    this["refBtnEliminar_" + normativida.id].current.hidden = false;
                }
                if( this["refInput_pre_" + normativida.id] ){             
                    inputsDisabled["refInput_pre_" + normativida.id].disabled = true;
                }
                if( this["refInput_res_" + normativida.id] ){             
                    inputsDisabled["refInput_res_" + normativida.id].disabled = true;
                }
                if( this["refInput_url_" + normativida.id] ){             
                    inputsDisabled["refInput_url_" + normativida.id].disabled = true;
                }
            }else{
                // Se habilita el elemento que se desea trabajar
                this["refBtnEdit_" + id].current.hidden = false;
                this["refBtnEliminar_" + id].current.hidden = false;
                this["refBtnSave_" + id].current.hidden = true;
                this["refBtnCancel_" + id].current.hidden = true;
                inputsDisabled["refInput_pre_" + id].disabled = true;
                inputsDisabled["refInput_res_" + id].disabled = true;
                inputsDisabled["refInput_url_" + id].disabled = true;
            }
        }

        if( id === 0 ){
            // Remueve el último item el cual se supone que es la nueva normatividad que ya no se va a agregar
            normatividades.pop(); 
            this.setSumaState({ normatividades, bloquearAgregar:false });    
        }
        
        this.setSumaState({ inputsDisabled });
    }

    clicGuardar = async ( id ) => {
        
        let normatividad_ = this["refInput_pre_" + id].current.resizableTextArea.props.value;
        let descripcion = this["refInput_res_" + id].current.resizableTextArea.props.value;
        let url = this["refInput_url_" + id].current.resizableTextArea.props.value;

        if( !Validadores.stringValido(normatividad_) ){
            Modal.error({ content: 'Debes ingresar la normatividad.' });
            return;
        }else if( !Validadores.validarTamano(normatividad_, 1, 500 ) ){
            Modal.error({ content: 'La normatividad no puede contener más de 500 caracteres.' });
            return;
        }
        
        if( !Validadores.stringValido(descripcion) ){
            Modal.error({ content: 'Debes ingresar la descripcion.' });
            return;
        }else if( !Validadores.validarTamano(descripcion, 1, 2000 ) ){
            Modal.error({ content: 'La descripcion no puede contener más de 2000 caracteres.' });
            return;
        }

        if( !Validadores.stringValido(url) ){
            Modal.error({ content: 'Debes ingresar la url del enlace.' });
            return;
        }else if( !Validadores.validarTamano(url, 1, 2000 ) ){
            Modal.error({ content: 'La url no puede contener más de 2000 caracteres.' });
            return;
        }

        this.setSumaState({ cargando: true });
        let normatividad = { id, normatividad:normatividad_, descripcion, url };
        let respuestaApi = id === 0 ?
                await this.servicioAdministracion.agregarNormatividad( normatividad ) :
                await this.servicioAdministracion.actualizarNormatividad( normatividad );

        if (respuestaApi) {
            switch (respuestaApi.codigo) {
                case Constantes.ENUMS_API.ADMINISTRACION.OPERACION_REALIZADA.id:
                    let inputsDisabled = this.state.inputsDisabled;
                    let normatividades = JSON.parse(JSON.stringify(this.state.normatividades ));
                    for( let i = 0; i < normatividades.length; i++ ){
                        normatividad = normatividades[i];
                        if( normatividad.id !== id ){
                            // Se deshabilitan los elementos que no se van a trabajar
                            if( this["refBtnEdit_" + normatividad.id] ){
                                this["refBtnEdit_" + normatividad.id].current.disabled = false;                
                            }
                            if( this["refBtnEliminar_" + normatividad.id] ){
                                this["refBtnEliminar_" + normatividad.id].current.disabled = false;                
                            }
                        }else{
                            // Se habilita el elemento que se desea trabajar
                            this["refBtnEdit_" + id].current.hidden = false;
                            this["refBtnEliminar_" + id].current.hidden = false;
                            this["refBtnSave_" + id].current.hidden = true;
                            this["refBtnCancel_" + id].current.hidden = true;
                            inputsDisabled["refInput_pre_" + id].disabled = true;
                            inputsDisabled["refInput_res_" + id].disabled = true;
                            inputsDisabled["refInput_url_" + id].disabled = true;
                            normatividad.normatividad = normatividad_;
                            normatividad.descripcion = descripcion;
                            normatividad.url = url;

                            if( id === 0 ){
                                normatividad.id = parseInt(respuestaApi.resultado);
                                this.crearReferencias( normatividad.id );
                                this.setSumaState({ bloquearAgregar:false }); 
                            }
                        }
                    }

                    this.setSumaState({ normatividades, inputsDisabled, cargando: false });
                    Modal.success({ content: 'Normatividad actualizada satisfactoriamente.' });
                    break;   
                default:
                    Modal.error({ content: 'No fue posible actualizar la normatividad. Por favor intenta mas tarde.' });
                    break;
            }
        }
    }

    clicAgregar = () => {
        let normatividades = this.state.normatividades;
        this.crearReferencias( 0 );

        for( let normatividad of normatividades ){
            // Se deshabilitan los elementos que no se van a trabajar
            if( this["refBtnEdit_" + normatividad.id] ){
                this["refBtnEdit_" + normatividad.id].current.disabled = true;                
                this["refBtnEdit_" + normatividad.id].current.hidden = false;
            }
            if( this["refBtnSave_" + normatividad.id] ){             
                this["refBtnSave_" + normatividad.id].current.hidden = true;
            }
            if( this["refBtnCancel_" + normatividad.id] ){             
                this["refBtnCancel_" + normatividad.id].current.hidden = true;
            }
            if( this["refBtnEliminar_" + normatividad.id] ){
                this["refBtnEliminar_" + normatividad.id].current.disabled = true;                
                this["refBtnEliminar_" + normatividad.id].current.hidden = false;
            }
            if( this["refInput_pre_" + normatividad.id] ){             
                this.inputsDisabled["refInput_pre_" + normatividad.id].disabled = true;
            }
            if( this["refInput_res_" + normatividad.id] ){             
                this.inputsDisabled["refInput_res_" + normatividad.id].disabled = true;
            }
            if( this["refInput_url_" + normatividad.id] ){             
                this.inputsDisabled["refInput_url_" + normatividad.id].disabled = true;
            }
        }
        normatividades.push({id:0,normatividad:"",descripcion:"",url:""});
        this.setSumaState({ normatividades, bloquearAgregar:true });
    }

    clicEliminar = async ( id ) => {

        this.setSumaState({ cargando: true });
        let respuestaApi = await this.servicioAdministracion.eliminarNormatividad( id )

        if (respuestaApi) {
            switch (respuestaApi.codigo) {
                case Constantes.ENUMS_API.ADMINISTRACION.OPERACION_REALIZADA.id:
                    let inputsDisabled = this.state.inputsDisabled;
                    let normatividades = JSON.parse(JSON.stringify(this.state.normatividades ));
                    for( let i = 0; i < normatividades.length; i++ ){
                        let normatividad = normatividades[i];   
                        if( normatividad.id === id ){
                            normatividades.splice(i,1);
                            break;
                        }
                    }

                    this["refInput_pre_" + id] = undefined;
                    this["refInput_res_" + id] = undefined;
                    this["refInput_url_" + id] = undefined;
                    this["refBtnEdit_" + id] = undefined;
                    this["refBtnSave_" + id] = undefined;
                    this["refBtnCancel_" + id] = undefined;
                    this["refBtnEliminar_" + id] = undefined;
                    this.inputsDisabled["refInput_pre_" + id] = undefined;
                    this.inputsDisabled["refInput_res_" + id] = undefined;
                    this.inputsDisabled["refInput_url_" + id] = undefined;

                    delete this["refInput_pre_" + id];
                    delete this["refInput_res_" + id];
                    delete this["refInput_url_" + id];
                    delete this["refBtnEdit_" + id];
                    delete this["refBtnSave_" + id];
                    delete this["refBtnCancel_" + id];
                    delete this["refBtnEliminar_" + id];
                    delete this.inputsDisabled["refInput_pre_" + id];
                    delete this.inputsDisabled["refInput_res_" + id];
                    delete this.inputsDisabled["refInput_url_" + id];


                    this.setSumaState({ normatividades, inputsDisabled, cargando: false });
                    Modal.success({ content: 'Normatividad eliminada satisfactoriamente.' });
                    break;   
                default:
                    Modal.error({ content: 'No fue posible eliminar la normatividad. Por favor intenta mas tarde.' });
                    break;
            }
        }

    }

    


    render() {
        const { componente, inputsDisabled, normatividades, bloquearAgregar } = this.state;
        const { TextArea } = Input;

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>
                            <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>
                                
                                {normatividades ? 
                                <>
                                    {normatividades.map( (normatividad, index) => (
                                    <div key={index} className="comunicaciones">
                                        <div className="pregunta normatividad">
                                            {inputsDisabled["refInput_pre_" + normatividad.id].disabled ?
                                                <div>
                                                    <span>Normatividad:&nbsp;</span>{normatividad.normatividad}
                                                </div> :
                                                <div className="texto-entrada">
                                                    <label>Normatividad:</label>
                                                    <TextArea  ref={this["refInput_pre_" + normatividad.id]} rows={1} defaultValue={normatividad.normatividad}/>
                                                </div>
                                            }
                                            {Utilidades.accionPermitida(this.props.usuario, Constantes.ENUMS_MODULOS.COMUNICACIONES.ACCIONES.EDITAR_NORMATIVIDAD.id) ?
                                                <Button ref={this["refBtnEdit_" + normatividad.id]} onClick={(e) => {this.clicEditar(normatividad.id);}}  icon={<EditOutlined />} hidden={normatividad.id === 0} /> : null
                                            }
                                            {Utilidades.accionPermitida(this.props.usuario, Constantes.ENUMS_MODULOS.COMUNICACIONES.ACCIONES.ELIMINAR_NORMATIVIDAD.id) ?
                                                <Popconfirm title={'Confirma eliminar la normatividad?'} 
                                                    okText="Si"
                                                    cancelText="No" 
                                                    onConfirm={(e) => {this.clicEliminar( normatividad.id )}}>
                                                        <Button ref={this["refBtnEliminar_" + normatividad.id]} className={"btn-rigth"} icon={<CloseOutlined />} type="primary" hidden={normatividad.id === 0}/>
                                                </Popconfirm> : null
                                            }

                                            <Popconfirm title={'Confirma editar la normatividad?'} 
                                                        okText="Si"
                                                        cancelText="No" 
                                                        onConfirm={(e) => {this.clicGuardar( normatividad.id )}}>
                                                <Button ref={this["refBtnSave_" + normatividad.id]}  type="primary" icon={<CheckOutlined />}  hidden={normatividad.id !== 0}/>
                                            </Popconfirm>
                                            <Button ref={this["refBtnCancel_" + normatividad.id]} className={"btn-rigth"} onClick={(e) => {this.clicCancelar(normatividad.id);}} icon={<CloseOutlined />} hidden={normatividad.id !== 0}/>
                                        </div>

                                        <div className="enlace">
                                            {inputsDisabled["refInput_url_" + normatividad.id].disabled ?
                                                <div>
                                                    <Tooltip title={normatividad.url}>
                                                        <Button type="link" href={normatividad.url} target="_blank">Ir a enlace url</Button> 
                                                    </Tooltip>
                                                </div>:
                                                <div className="texto-entrada">
                                                    <label>Enlace:</label>
                                                    <TextArea ref={this["refInput_url_" + normatividad.id]} rows={1} defaultValue={normatividad.url}/>
                                                </div>
                                            }
                                        </div>    

                                        <div className="respuesta">
                                            {inputsDisabled["refInput_res_" + normatividad.id].disabled ?
                                                <div><span>Descripción:&nbsp;</span>{normatividad.descripcion}</div> :
                                                <div className="texto-entrada">
                                                    <label>Descripción:</label>
                                                    <TextArea ref={this["refInput_res_" + normatividad.id]} rows={4} defaultValue={normatividad.descripcion}/>
                                                </div>
                                            }
                                        </div>
                                        
                                    </div> 
                                    ))}

                                    {Utilidades.accionPermitida(this.props.usuario, Constantes.ENUMS_MODULOS.COMUNICACIONES.ACCIONES.AGREGAR_NORMATIVIDAD.id) ?
                                        <Button type="primary" onClick={(e) => {this.clicAgregar();}}  icon={<PlusOutlined />} disabled={bloquearAgregar}>
                                            Agregar normatividad
                                        </Button> : null }

                                </>
                                : null }

                            </Spin>

                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:NORM]</label>) : (<></>))
                    )
                }
            </div>
        );
    }
}

export default withRouter(withCookies(Normatividad));